import { useEffect } from 'react';
import { API_URL } from '../../services/api';

export default function GoogleCallbackProxy() {
  useEffect(() => {
    // Redirect to the actual backend endpoint, passing along the query parameters (like code, state, etc.)
    window.location.href = `${API_URL}/api/auth/google/callback${window.location.search}`;
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-[#0B0F19]">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-[#3B82F6] border-t-transparent"></div>
        <p className="mt-4 text-gray-400">Completing authentication...</p>
      </div>
    </div>
  );
}
